<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
  <span style=" padding: 5px 7px 15px;" class="title-header">{{'verify-enterprice.title' | translate}}</span>
  <!--  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">-->
  <!--    <span aria-hidden="true">&times;</span>-->
  <!--  </button>-->
</h2>
<mat-divider></mat-divider>
<div class="row" style="margin: unset!important;">
    <div class="content" [innerHTML]="data.message | translate" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;"></div>
</div>


<div mat-dialog-actions class="justify-content-center">
  <button class="ml-2" mat-raised-button color="primary" [mat-dialog-close]="true">
    <span *ngIf="data.hashKey && data.tenantId">
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" style="margin-bottom: 2px">
<g clip-path="url(#clip0_5518_46646)">
<path d="M16.3333 2.16667H12.85C12.5 1.2 11.5833 0.5 10.5 0.5C9.41667 0.5 8.5 1.2 8.15 2.16667H4.66667C3.75 2.16667 3 2.91667 3 3.83333V17.1667C3 18.0833 3.75 18.8333 4.66667 18.8333H16.3333C17.25 18.8333 18 18.0833 18 17.1667V3.83333C18 2.91667 17.25 2.16667 16.3333 2.16667ZM10.5 2.16667C10.9583 2.16667 11.3333 2.54167 11.3333 3C11.3333 3.45833 10.9583 3.83333 10.5 3.83333C10.0417 3.83333 9.66667 3.45833 9.66667 3C9.66667 2.54167 10.0417 2.16667 10.5 2.16667ZM15.5 17.1667H5.5C5.04167 17.1667 4.66667 16.7917 4.66667 16.3333V4.66667C4.66667 4.20833 5.04167 3.83333 5.5 3.83333H6.33333V4.66667C6.33333 5.58333 7.08333 6.33333 8 6.33333H13C13.9167 6.33333 14.6667 5.58333 14.6667 4.66667V3.83333H15.5C15.9583 3.83333 16.3333 4.20833 16.3333 4.66667V16.3333C16.3333 16.7917 15.9583 17.1667 15.5 17.1667Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_5518_46646">
<rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"/>
</clipPath>
</defs>
</svg> {{'verify-enterprice.sign' | translate}}
    </span>
    <span *ngIf="!data.hashKey && !data.tenantId">
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" style="margin-bottom: 2px">
<g clip-path="url(#clip0_5518_46646)">
<path d="M16.3333 2.16667H12.85C12.5 1.2 11.5833 0.5 10.5 0.5C9.41667 0.5 8.5 1.2 8.15 2.16667H4.66667C3.75 2.16667 3 2.91667 3 3.83333V17.1667C3 18.0833 3.75 18.8333 4.66667 18.8333H16.3333C17.25 18.8333 18 18.0833 18 17.1667V3.83333C18 2.91667 17.25 2.16667 16.3333 2.16667ZM10.5 2.16667C10.9583 2.16667 11.3333 2.54167 11.3333 3C11.3333 3.45833 10.9583 3.83333 10.5 3.83333C10.0417 3.83333 9.66667 3.45833 9.66667 3C9.66667 2.54167 10.0417 2.16667 10.5 2.16667ZM15.5 17.1667H5.5C5.04167 17.1667 4.66667 16.7917 4.66667 16.3333V4.66667C4.66667 4.20833 5.04167 3.83333 5.5 3.83333H6.33333V4.66667C6.33333 5.58333 7.08333 6.33333 8 6.33333H13C13.9167 6.33333 14.6667 5.58333 14.6667 4.66667V3.83333H15.5C15.9583 3.83333 16.3333 4.20833 16.3333 4.66667V16.3333C16.3333 16.7917 15.9583 17.1667 15.5 17.1667Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_5518_46646">
<rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"/>
</clipPath>
</defs>
</svg> {{'verify-enterprice.sign' | translate}}
    </span>
  </button>
</div>
